import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, tap } from 'rxjs';
import { PaymentType } from '@app/shared/enums/payment-type.enum';
import { SEOService, CountdownService, ISeoTagType } from '@app/shared/services';
import { BookingCompletedVisitDetailsDirective } from '@app/booking-part/booking-completed/booking-completed-summary/booking-completed-visit-details.directive';

@Component({
  selector: 'app-booking-completed',
  templateUrl: './booking-completed.component.html',
  styleUrls: ['./booking-completed.component.scss']
})
export class BookingCompletedComponent extends BookingCompletedVisitDetailsDirective implements OnInit, OnDestroy {
  public PaymentType = PaymentType;
  public countdownRedirectInSeconds = 5;
  private router = inject(Router);
  private seoService = inject(SEOService);
  private countdown = inject(CountdownService);

  constructor() {
    super();
    this.setSEO();
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.shouldRedirectToSalonWebpageOnRouteBySalonId) {
      return;
    }

    this.countdown.getSecondsCountdown$(this.countdownRedirectInSeconds)
      .pipe(
        tap((remainingSeconds: number) => this.countdownRedirectInSeconds = remainingSeconds),
        finalize(() => this.returnToSalonWebsite()))
      .subscribe();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public returnToSalonWebsite(): void {
    window.location.replace(this.bookingReturnUrl);
  }

  public bookAnotherVisit(): void {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  private setSEO(): void {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'BOOKING-PART.BOOKING-COMPLETED.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'BOOKING-PART.BOOKING-COMPLETED.META-DESCRIPTION'
      }
    ]);
  }
}
